import React, { createContext, useContext } from 'react'
import { Project, Query } from '@/types/codegen-federation'

export type ProjectByPhase = NonNullable<NonNullable<Query['projectsInCurrentPhase']>[number]>

const ProjectByPhaseContext = createContext<Project | null>(null)

export const useProjectByPhaseContext = () => {
  const projectContext = useContext(ProjectByPhaseContext)

  if (!projectContext) {
    throw new Error('useProjectByPhaseContext must be used within a ProjectByPhaseProvider!')
  }

  return projectContext
}

interface ProjectByPhaseProviderProps {
  children: React.ReactNode
  project: Project
}

export const ProjectByPhaseProvider: React.FC<ProjectByPhaseProviderProps> = ({ children, project }) => {
  return <ProjectByPhaseContext.Provider value={project}>{children}</ProjectByPhaseContext.Provider>
}
